import { createAction } from 'redux-actions';
import { getTrialBalanceTaggedElements } from 'api/trial-balance-api';

export const trialBalanceTaggedElementsLoaded = createAction(
  'TRIAL_BALANCE_TAGGED_ELEMENTS_LOADED',
);
export const trialBalanceTaggedElementsLoading = createAction(
  'TRIAL_BALANCE_TAGGED_ELEMENTS_LOADING',
);
export const trialBalanceTaggedElementsError = createAction(
  'TRIAL_BALANCE_TAGGED_ELEMENTS_ERROR',
);

export const getTrialBalanceTaggedElementsData =
  () => async (dispatch, getState) => {
    const { data } = getState();
    const {
      revision,
      selectedProject: { id },
      selectedStatement: { statementId },
    } = data;

    try {
      dispatch(trialBalanceTaggedElementsLoading());
      const response = await getTrialBalanceTaggedElements({
        statementId: parseInt(statementId),
        revisionId: parseInt(revision?.id),
        clientId: parseInt(id),
      });
      if (response?.status === 200) {
        dispatch(trialBalanceTaggedElementsLoaded(response));
      }
    } catch (error) {
      console.error(
        'Get trial balance tagged elements request failed with error: ',
        error,
      );
      dispatch(trialBalanceTaggedElementsError(error));
    }
  };
